const defaultFields = () => ({
	name: null,
	email: null,
    phone: null,
    note: null,
	company_name: null,
	company_description: null,
	company_address: null,
})

const defaultListFields = () => (
	[
		{
			name: null,
			email: null,
            phone: null,
            note: null,
			company_name: null,
			company_description: null,
			company_address: null,
		}
	]
)

export {
	defaultFields, defaultListFields
}
